import BlogPlugin from '@d-shared/plugins/blog-plugin/blog-plugin';
import ErrorHandlerPlugin from '@d-shared/plugins/error-handler-plugin/error-handler-plugin';
import EventsTracking from '@d-shared/plugins/events-tracking/events-tracking';
import ExitModalHandlerPlugin from '@d-shared/plugins/exit-modal-handler/exit-modal-handler';
import ModalHandlerPlugin from '@d-shared/plugins/modal-handler/modal-handler';
import PolyfillsPlugin from '@d-shared/plugins/polyfills-plugin/polyfills-plugin';
import SignupModal from '@d-shared/plugins/signup-modal/signup-modal';
import TrackingHandlerPlugin from '@d-shared/plugins/tracking-handler/tracking-handler';

export default [
  BlogPlugin,
  ErrorHandlerPlugin,
  EventsTracking,
  ExitModalHandlerPlugin,
  ModalHandlerPlugin,
  PolyfillsPlugin,
  SignupModal,
  TrackingHandlerPlugin,
];
